var $3d11d74855233b86$exports = {};
$3d11d74855233b86$exports = {
  "collapse": "Recolher",
  "expand": "Expandir"
};
export { $3d11d74855233b86$exports as default };